import { Color, Spacing, Typography } from '@persona-id/design-tokens';
import styled from 'styled-components';

export const ModalV2Header = styled('div')`
  ${Typography.HeadingMedium};
`;

export const ModalV2Subheader = styled('div')`
  ${Typography.TextMediumBold};
  color: ${Color.CorePurple700};
`;

export const ModalV2Footer = styled('div')`
  position: sticky;
  bottom: 0px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  column-gap: ${Spacing[4]};
  padding: ${Spacing[4]} ${Spacing[6]};
  background-color: ${({ theme }) => theme.color.background.secondary};
  border-bottom-left-radius: ${({ theme }) => theme.card.borderRadius};
  border-bottom-right-radius: ${({ theme }) => theme.card.borderRadius};
`;
